import { Link } from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import footerRoutes from '../../footer.routes'

const Footer = () => {
  const { t } = useTranslation('common')
  const { brand, socials, menus } = footerRoutes
  const date = new Date().getFullYear()

  return (
    <Box component='footer'>
      <Container>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }} sx={{ ml: 'auto', mb: 3 }}>
            <Box>
              <Link to={brand.route}>
                <Box component='img' src={brand.image} alt={brand.name} sx={{ maxWidth: '9rem', width: '100%', height: 'auto', mb: 2 }} />
              </Link>
              <Typography variant='h6'>{brand.name}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
              {socials?.map(({ icon, link }, key) => (
                <Box
                  key={link}
                  component='a'
                  href={link}
                  target='_blank'
                  rel='noreferrer'
                  sx={{ mr: key === socials.length - 1 ? 0 : 2 }}
                >
                  {icon}
                </Box>
              ))}
            </Box>
          </Grid>
          {menus.map(({ name: title, items }) => (
            <Grid key={title} size={{ xs: 6, md: 2 }} sx={{ mb: 3 }}>
              <Typography
                variant='button'
                sx={{
                  display: 'block',
                  fontWeight: 'bold',
                  textTransform: 'capitalize',
                  mb: 1
                }}
              >
                {t(`footer.${title}`)}
              </Typography>
              <Box component='ul' sx={{ p: 0, m: 0, listStyle: 'none' }}>
                {items.map(({ name, route, href }) => (
                  <Box key={name} component='li' sx={{ p: 0, m: 0, lineHeight: 1.25 }}>
                    {href
                      ? (
                        <Typography
                          component='a'
                          href={href}
                          target='_blank'
                          rel='noreferrer'
                          variant='button'
                          sx={{
                            fontWeight: 'regular',
                            textTransform: 'capitalize'
                          }}
                        >
                          {t(`footer.${name}`)}
                        </Typography>
                        )
                      : (
                        <Link style={{ lineHeight: '28px', textDecoration: 'none', color: '#999' }} to={route}>
                          {t(`footer.${name}`)}
                        </Link>
                        )}
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
          <Grid size={12} sx={{ textAlign: 'center', my: 3 }}>
            <Typography variant='caption' sx={{ fontWeight: 'regular' }}>
              {t('footer.allRightsReserved')} © {date}{' '}
              <MuiLink
                href='https://www.peakssports.com/'
                target='_blank'
                rel='noreferrer'
                sx={{
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  color: '#999 !important',
                  '&:link, &:visited, &:hover, &:focus, &:active': {
                    color: '#999 !important',
                  },
                }}
              >
                Peaks Sports
              </MuiLink>
              .
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Footer
